import { Permission, UI_TERMS } from '@bookora/shared';

import type { TourDef } from './types';

/**
 * «بسته‌های خدمات» (`/packages`): the bundles a clinic defines (package.manage) and
 * the ones it has sold (package.sell to sell). `?new=1` opens «تعریف بسته خدمات
 * تازه» and is consumed on arrival. A session is drawn off a sold package
 * when it is recorded, in the session form — not here.
 */
export const PACKAGES_TOUR: TourDef = {
  key: 'packages',
  version: 1,
  surface: 'page',
  title: UI_TERMS.packages,
  hubDescription: 'تعریف بسته خدمات چندجلسه‌ای، فروش به بیمار و جلسه‌های درمان باقی‌مانده.',
  offer: {
    body: 'در چند قدم کوتاه نشونتون می‌دیم بسته خدمات چندجلسه‌ای چطور تعریف و فروخته می‌شه.',
  },
  route: { path: '/packages', match: (pathname) => pathname === '/packages' },
  requires: { all: [Permission.PACKAGE_VIEW] },
  finish: {
    label: 'تعریف بسته خدمات جدید',
    to: '/packages?new=1',
    requires: { all: [Permission.PACKAGE_MANAGE] },
  },
  autoOffer: true,
  maxSteps: 3,
  minSteps: 2,
  steps: [
    {
      id: 'bundles',
      anchor: 'packages.tab-bundles',
      placement: 'bottom',
      title: 'بسته‌های خدمات کلینیک',
      body: (ctx) =>
        ctx.can(Permission.PACKAGE_SELL)
          ? 'بسته خدمات یعنی چند جلسه درمان از یک یا چند خدمت با یک قیمت، مثل «شش جلسه لیزر». هر بسته خدمات از همین فهرست به بیمار فروخته می‌شه.'
          : 'بسته خدمات یعنی چند جلسه درمان از یک یا چند خدمت با یک قیمت، مثل «شش جلسه لیزر».',
    },
    {
      id: 'add',
      anchor: 'packages.add',
      placement: 'bottom-end',
      requires: { all: [Permission.PACKAGE_MANAGE] },
      title: 'تعریف بسته خدمات',
      body: 'نام، خدمات، تعداد جلسات، قیمت و مدت اعتبار از روز خرید رو وارد کنید.',
    },
    {
      id: 'sales',
      anchor: 'packages.tab-sales',
      placement: 'bottom',
      title: 'بسته‌های خدمات فروخته‌شده',
      body: 'هر بسته خدماتی که به بیمار فروخته شده، با جلسه‌های درمان باقی‌مانده و مانده‌حساب. هر بار که جلسه درمانی از این بسته ثبت می‌کنید، یکی از جلسه‌های باقی‌مانده کم می‌شه.',
    },
  ],
};
